import { Col, Row, Card, Progress, Typography } from "antd";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
const { Text } = Typography;

const CardsPercentageLoad = ({ load, type, action }) => {
	const [percentagePlant, setPercentagePlant] = useState(0);
	const [percentageJobSite, setPercentageJobSite] = useState(0);

	useEffect(() => {
		callGetLoad();
	}, [load]);

	const callGetLoad = async () => {
		let percentagePlant = 0;
		let percentageJobSite = 0;

		if (
			load.plantSlumpUrl !== undefined &&
			load.plantSlumpUrl !== null &&
			load.plantSlumpUrl !== ""
		)
			percentagePlant += 50;
		if (
			load.plantTemperatureUrl !== undefined &&
			load.plantTemperatureUrl !== null &&
			load.plantTemperatureUrl !== ""
		)
			percentagePlant += 50;
		if (
			load.jobSiteSlumpUrl !== undefined &&
			load.jobSiteSlumpUrl !== null &&
			load.jobSiteSlumpUrl !== ""
		)
			percentageJobSite += 25;
		if (
			load.jobSiteTemperatureUrl !== undefined &&
			load.jobSiteTemperatureUrl !== null &&
			load.jobSiteTemperatureUrl !== ""
		)
			percentageJobSite += 25;
		if (
			load.jobSiteDrumRotation !== undefined &&
			load.jobSiteDrumRotation !== null
		)
			percentageJobSite += 25;
		if (load.jobSiteWaterAdded !== undefined && load.jobSiteWaterAdded !== null)
			percentageJobSite += 25;

		setPercentagePlant(percentagePlant);
		setPercentageJobSite(percentageJobSite);
	};

	return (
		<Row gutter={16}>
			<Col span={8}>
				<Card
					title="Plant"
					variant="borderless"
					onClick={() => action("plant")}
					style={{
						backgroundColor: type === "plant" ? "#c1cbdb" : "#ffffff",
						cursor: "pointer",
					}}
				>
					<Progress percent={percentagePlant} status="active" />
					<p
						style={{
							color: percentagePlant === 100 ? "#289d3aff" : "#a81c1cff",
						}}
					>
						{percentagePlant < 100 ? "Incompleted" : "Completed"}
					</p>
				</Card>
			</Col>

			<Col span={8}>
				<Card
					title="Job Site"
					variant="borderless"
					onClick={() => action("jobsite")}
					style={{
						backgroundColor: type === "jobsite" ? "#c1cbdb" : "#ffffff",
						cursor: "pointer",
					}}
				>
					<Progress percent={percentageJobSite} status="active" />
					<Text
						strong
						style={{
							color: percentageJobSite === 100 ? "#289d3aff" : "#a81c1cff",
						}}
					>
						{percentageJobSite < 100 ? "Incompleted" : "Completed"}
					</Text>
				</Card>
			</Col>
		</Row>
	);
};

export default CardsPercentageLoad;
